$(function () {
  // Basic Sliders
  var carouselSliders = $('.banner .banner-slides');
  carouselSliders.each(function () {
    var sliderParent = $(this).parent();

    $(this).slick({
      arrows: true,
      autoplay: false,
      dots: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      rows: 0,
      speed: 1500,
      prevArrow: $(sliderParent).find('.slick-prev'),
      nextArrow: $(sliderParent).find('.slick-next'),
    });
  });

  var ctaCarouselSliders = $('.cta-carousel-slider .carousel-slides');
  ctaCarouselSliders.each(function () {
    var sliderParent = $(this).parent();
    var slidesToShow = 5;

    var $slides = $(this).find('.carousel-slide');
    if ($slides.length < slidesToShow) {
      slidesToShow = $slides.length % 2 == 1 ? $slides.length : $slides.length - 1;
    } else if ($slides.length == slidesToShow) {
      slidesToShow = 3;
    }

    $(this).slick({
      slidesToShow: slidesToShow,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      infinite: true,
      arrows: true,
      autoplay: false,
      dots: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      rows: 0,
      prevArrow: $(sliderParent).find('.slick-prev'),
      nextArrow: $(sliderParent).find('.slick-next'),
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 3,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });

  var linkedCarouselSliders = $('.linked-carousel-slider .carousel-slides');
  linkedCarouselSliders.each(function () {
    var sliderParent = $(this).parent();

    $(this).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      centerMode: true,
      centerPadding: 0,
      infinite: true,
      arrows: true,
      autoplay: false,
      dots: false,
      pauseOnFocus: true,
      pauseOnHover: true,
      rows: 0,
      prevArrow: $(sliderParent).find('.slick-prev'),
      nextArrow: $(sliderParent).find('.slick-next'),
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          },
        },
      ],
    });
  });

  $(window).on('load resize orientationchange', function () {
    $('.articles-list.carousel').each(function () {
      var sliderParent = $(this).parent();

      if ($(window).width() > 1150) {
        if ($(this).hasClass('slick-initialized')) {
          $(this).slick('unslick');
        }
      } else {
        if (!$(this).hasClass('slick-initialized')) {
          $(this).slick({
            arrows: true,
            dots: true,
            autoplay: false,
            mobileFirst: true,
            prevArrow: $(sliderParent).find('.slick-prev'),
            nextArrow: $(sliderParent).find('.slick-next'),
          });
        }
      }
    });
  });
});
